//this function checks if a strign contains html code (this is used for the messages displayed in the home screen)

export const isHTML = (str: string): boolean => {
    let doc = new DOMParser().parseFromString(str, "text/html");

    return Array.from(doc.body.childNodes).some((val) => val.nodeType === 1);
}